import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { doc, Firestore, getDoc } from '@angular/fire/firestore';
import { Router, type CanActivateFn } from '@angular/router';
import { environment } from '@environments/environment';
import { Genre, UserModel } from '@interfaces/user.model';
import { UserService } from '@services/user.service';

export const onboardingGuardGuard: CanActivateFn = async (route, state) => {
	const router = inject(Router);
	const auth = inject(Auth);
	const firestore = inject(Firestore);
	const userService = inject(UserService);
	const id = auth.currentUser?.uid;

	if (!id) {
		router.navigate(['/auth']);
		console.log('No user id');
		return false;
	}

	let user: UserModel | null = userService.user();

	if (!user) {
		const userDoc = await getDoc(
			doc(firestore, `companies/${environment.companyId}/users/${id}`)
		);
		if (
			!userDoc.exists() ||
			isPersonalDataInvalid(userDoc.data() as UserModel)
		) {
			router.navigate(['/onboarding']);
			return false;
		}

		user = userDoc.data() as UserModel;
	}

	console.log({ onboardingGuardUser: user });
	userService.user.set(user);

	// if current route is /onboarding, return true
	if (state.url === '/onboarding') {
		return true;
	}

	const personalDataInvalid = isPersonalDataInvalid(user);
	console.log({ personalDataInvalid });

	if (personalDataInvalid) {
		router.navigate(['/onboarding']);
		return false;
	}

	return true;
};

export function isPersonalDataInvalid(user: UserModel) {
	console.log({ user });
	return (
		!user.personalData ||
		!user.personalData?.firstName ||
		!user.personalData?.lastName ||
		!user.personalData?.birthday ||
		!user.personalData?.phone ||
		!user.personalData?.dni ||
		!user.personalData?.genre ||
		user.personalData?.genre === Genre.Undefined
	);
}
